var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderWarehouseReport',{attrs:{"img_header":_vm.img_header,"header":"จำนวนสินค้าคงเหลือ","link_back":"warehousereport"}}),_c('Warehouse_quantity')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }